import get from 'lodash/get';

import store from 'Redux/store';
import { cartItemsSelector } from 'Redux/reselects/order-calc/cart-display';
import { cartUnitCountSelector } from 'Redux/reselects/order-calc/cart-readers';

/**
 * Helper functions for dealing with redux state
 * Only functions that interact with the current state should be added here
 * @type {Object}
 */

const State = {};

State.getState = (type) => {
  const state = store.getState();
  if (type) {
    return get(state, type, {});
  }
  return state;
};

State.getAnonId = () => {
  const anonymous = State.getState('anonymous');
  return get(anonymous, 'id');
};

State.getUserId = () => {
  const auth = State.getState('auth');
  return get(auth, '_id') || State.getAnonId();
};

State.getPageId = () => {
  const router = State.getState('router');
  return get(router, 'location.pathname');
};

// One entry for each unit of the cart (a product with quantity 2 counts 2)
State.getCartUnitCount = () => cartUnitCountSelector(State.getState());

// The cart items in display order, one entry for each unit: cartBefore
// (getCartItemsString) keeps the order of the cart page
State.getCartItems = () => cartItemsSelector(State.getState());

State.getCartItemsString = () => {
  const items = State.getCartItems();
  return items.map(cartItem => cartItem._id).toString();
};

State.getGiftOrderData = () => {
  const gift = State.getState('gift');
  return get(gift, 'giftOrder');
};

export default State;
